import { ChangeDetectorRef, Pipe, PipeTransform } from '@angular/core';
import { WorkflowItemQueriesService } from '@workflow/queries/services/workflow-item-queries.service';
import { Subscription } from 'rxjs';
import { UnsubscribeOnDestroy } from '@app/util/lifecycle-hooks/lifecycle-hooks';
import { QueryState, WorkflowQueryDto } from '@interfaces/queries';

@Pipe({
	name: 'queryState',
	pure: false
})
export class QueryStatePipe implements PipeTransform {
	@UnsubscribeOnDestroy
	private readonly subscription = new Subscription();
	private queries: WorkflowQueryDto[] = [];
	
	constructor(
		workflowItemQueriesService: WorkflowItemQueriesService,
		cdr: ChangeDetectorRef
	) {
		this.subscription.add(
			workflowItemQueriesService.active$.subscribe(active => {
				this.queries = active;
				
				// trigger re-evaluation of the pipe
				cdr.markForCheck();
			})
		);
	}
	
	public transform(key: string): QueryState | null {
		return this.queries.find(q => q.workflowKey === key)?.state ?? null;
	}
	
}
